import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {dateFromMask} from '../utils/date-utils';

export class MaskedDateValidators {

    static valid(todayValidation = false): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const inputDate = control.value;
            if (inputDate) {
                const date = dateFromMask(inputDate);

                if (!date.isValid() || date.year() < 1900) {
                    return {invalidDateFormat: true};
                } else if (todayValidation && date.isBefore(new Date())) {
                    return {invalidDate: true};
                }
            }
            return null;
        };
    }

    static rangeValid(minFormControlName: string, maxFormControlName: string): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const startDateControl = formGroup.get(minFormControlName);
            const endDateControl = formGroup.get(maxFormControlName);
            const startDate = dateFromMask(startDateControl.value);
            const endDate = dateFromMask(endDateControl.value);
            const isInvalidRange = startDate.isValid() && endDate.isValid() && startDate.isAfter(endDate);

            [startDateControl, endDateControl].forEach(control => {
                delete control.errors?.invalidRange;
                if (isInvalidRange) {
                    control.setErrors({...control.errors, invalidRange: true});
                    control.markAsTouched();
                } else {
                    control.updateValueAndValidity({onlySelf: true});
                }
            });
            return null;
        };
    }
}
